module.exports = __webpack_public_path__ + "static/media/Design_simpleflow.48c160c3.png";